import React from 'react';
import { DownloadIcon } from '../../ui/icons';
import { Button, makeStyles } from '../../ui';
import { CellProps } from '../common/table';
import { BillingTableItem } from './types';

const getAuthToken = () => JSON.parse(localStorage['kl.jwtToken']);

const useButtonStyles = makeStyles(() => ({
  root: {
    padding: 0,
    minWidth: 0,
    width: '44px',
    height: '44px',
  },
}));

export type DownloadCellProps = Pick<CellProps<BillingTableItem, string>, 'value' | 'row'>;

export const DownloadCell: React.FC<DownloadCellProps> = ({ value, row }) => {
  const buttonClasses = useButtonStyles();
  const { InvoiceNumber, itemType } = row.original;
  const params = new URLSearchParams({ [`${itemType}Id`]: value, token: getAuthToken() });
  const href = `/webshop-api/download/billing?${params.toString()}`;

  return (
    <Button
      component='a'
      color='primary'
      variant='outlined'
      classes={buttonClasses}
      href={href}
      download
      target='_blank'
      aria-label={`download ${InvoiceNumber}`}
    >
      <DownloadIcon fontSize='large' />
    </Button>
  );
};
